// hooks/useHeicConverter.js
import heic2any from "heic2any";

export const useHeicConverter = () => {
    const isHeic = (file) => {
        return (
            file?.type === "image/heic" ||
            file?.type === "image/heif" ||
            file?.name?.toLowerCase().endsWith(".heic") ||
            file?.name?.toLowerCase().endsWith(".heif")
        );
    };

    const convertHeicToJpg = async (file) => {
        try {
            const convertedBlob = await heic2any({
                blob: file,
                toType: "image/jpeg",
                quality: 0.8,
            });

            return new File(
                [convertedBlob],
                file.name.replace(/\.(heic|heif)$/i, ".jpg"),
                { type: "image/jpeg" }
            );
        } catch (error) {
            console.error("HEIC conversion failed", error);
            return file; // fallback
        }
    };

    const processFile = async (file) => {
        if (isHeic(file)) {
            return await convertHeicToJpg(file);
        }
        return file;
    };

    return {
        isHeic,
        convertHeicToJpg,
        processFile,
    };
};
